import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useSettings } from "../context/SettingsContext";

export const HIDEABLE_PAGES = [
    { k: "gallery", label: "Prints (Gallery)" },
    { k: "originals", label: "Originals" },
    { k: "commissions", label: "Commissions" },
    { k: "about", label: "About" },
];

export const AdminPagesPanel = () => {
    const { settings, refresh } = useSettings();
    const [busy, setBusy] = useState(null);
    const hidden = settings.hidden_pages || [];

    const toggle = async (k) => {
        setBusy(k);
        const next = hidden.includes(k) ? hidden.filter((x) => x !== k) : [...hidden, k];
        try {
            await api.put("/admin/settings", { hidden_pages: next });
            await refresh();
            toast.success(next.includes(k) ? "Page hidden from site" : "Page visible again");
        } catch (e) {
            toast.error("Update failed");
        } finally { setBusy(null); }
    };

    return (
        <div className="max-w-3xl" data-testid="admin-pages-panel">
            <p className="text-sm text-[#5A5A5A] mb-6">Hidden pages are removed from the menu and footer, and visitors who open their link see a "page not found" screen.</p>
            <div className="grid gap-3">
                {HIDEABLE_PAGES.map((p) => {
                    const isHidden = hidden.includes(p.k);
                    return (
                        <div key={p.k} className={`flex items-center justify-between p-4 bg-[#F0EDE5] border border-black/[0.06] ${isHidden ? "opacity-60" : ""}`} data-testid={`admin-page-row-${p.k}`}>
                            <div className="font-serif-display text-xl text-[#1A1A1A]">
                                {p.label}
                                <span className="ml-3 label-caps text-[#8A8A8A]">{isHidden ? "· hidden" : "· visible"}</span>
                            </div>
                            <button
                                onClick={() => toggle(p.k)}
                                disabled={busy === p.k}
                                className="px-4 py-2 border border-black/20 text-xs tracking-[0.2em] uppercase hover:bg-black/5 transition-colors disabled:opacity-50"
                                data-testid={`admin-page-toggle-${p.k}`}
                            >
                                {isHidden ? "Show" : "Hide"}
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
